<template>
  <div id="TopMenu">
    <!-- desktop version -->
    <div class="menu top-menu hide-in-mobile"
      v-if="getIsMobile == false"
      v-show-mobile-mode="false">
      <ul
        :class="[
          this.has_custom_colors ? 'default' : '',
          this.out_off_stage_top == false ? '' : 'out-off-top' ]"
        :style="this.background_style">
        <li>
          <router-link :to="{ name: 'Portal' }"
            :class="this.has_custom_colors ? '' : 'default'"
            :style="this.text_style"
            @click.native="scrollMeTo('top')"
            @mouseover.native="mouseOver($event)"
            @mouseleave.native="mouseLeave($event)">
            計畫說明
          </router-link>
        </li>
        <li>
          <router-link to="/#series6"
            :class="this.has_custom_colors ? '' : 'default'"
            :style="this.text_style"
            @click.native="itemClick($event, '#series6')"
            @mouseover.native="mouseOver($event)"
            @mouseleave.native="mouseLeave($event)">
            磨課師課程
          </router-link>
        </li>
        <li>
          <router-link to="/#series1"
            :class="this.has_custom_colors ? '' : 'default'"
            :style="this.text_style"
            @click.native="itemClick($event, '#series1')"
            @mouseover.native="mouseOver($event)"
            @mouseleave.native="mouseLeave($event)">
            雲端數位外語學院
          </router-link>
        </li>
        <!-- <li><a @click.prevent="goUrl(2, 2)" href>VR Class ∞ 虛擬教室無限大</a></li> -->
        <li>
          <router-link to="/#series5"
            :class="this.has_custom_colors ? '' : 'default'"
            :style="this.text_style"
            @click.native="itemClick($event, '#series5')"
            @mouseover.native="mouseOver($event)"
            @mouseleave.native="mouseLeave($event)">
            土地開發
          </router-link>
        </li>
        <li>
          <router-link to="/#series3"
            :class="this.has_custom_colors ? '' : 'default'"
            :style="this.text_style"
            @click.native="itemClick($event, '#series3')"
            @mouseover.native="mouseOver($event)"
            @mouseleave.native="mouseLeave($event)">
            師資培育
          </router-link>
        </li>
        <li>
          <router-link to="/#series4"
            :class="this.has_custom_colors ? '' : 'default'"
            :style="this.text_style"
            @click.native="itemClick($event, '#series4')"
            @mouseover.native="mouseOver($event)"
            @mouseleave.native="mouseLeave($event)">
            多元特色課程
          </router-link>
        </li>
        <!-- <li><a @click.prevent="goPortal('#about-project')" href="">翻轉學習發展重點</a></li> -->
        <li>
          <router-link to="/#about-project"
            :class="this.has_custom_colors ? '' : 'default'"
            :style="this.text_style"
            @click.native="itemClick($event, '#about-project')"
            @mouseover.native="mouseOver($event)"
            @mouseleave.native="mouseLeave($event)">
            翻轉學習發展重點
          </router-link>
        </li>
        <!-- <li><a href="#about-team">計畫團隊</a></li> -->
        <li>
          <router-link to="/#about-team"
            :class="this.has_custom_colors ? '' : 'default'"
            :style="this.text_style"
            @click.native="itemClick($event, '#about-team')"
            @mouseover.native="mouseOver($event)"
            @mouseleave.native="mouseLeave($event)">
            計畫團隊
          </router-link>
        </li>
        <li>
          <router-link to="/#course-apply"
            class="default course-apply"
            :style="this.text_style"
            @click.native="itemClick($event, '#course-apply')"
            >
            課程申請
          </router-link>
        </li>
      </ul>
      <a class="login-button" href="" target="_blank" v-on:click.prevent="clickLogin"></a>
    </div>
    <!-- mobile & tablet version -->
    <div class="menu menu-mobile hide-not-mobile"
      v-show="getIsMobile == true || getIsTablet == true">
      <div class="hidden-always menu-mobile-hotspot"></div>
      <div class="sprite logo">
        <div class="sprite-logo_white sprite-logo_white-absolute"></div>
      </div>
    </div>
    <Slide ref="SideMenu" class="menu-container hide-not-mobile"
      :burgerIcon="false" :crossIcon="false" :width="expand_menu_width"
      v-if="getIsMobile == true"
      @openMenu="handleOpenMenu"
      v-bind:isOpen="menuOpenState">
      <router-link :to="{ name: 'Portal' }"
        :class="this.has_custom_colors ? '' : 'default'"
        :style="this.text_style"
        @mouseover.native="mouseOver($event)"
        @mouseleave.native="mouseLeave($event)">
        計畫說明
      </router-link>
      <router-link to="/#series1"
        :class="this.has_custom_colors ? '' : 'default'"
        :style="this.text_style"
        @mouseover.native="mouseOver($event)"
        @mouseleave.native="mouseLeave($event)">
        雲端數位外語學院
      </router-link>
      <router-link to="/#series5"
        class="more-lines"
        :class="this.has_custom_colors ? '' : 'default'"
        :style="this.text_style"
        @mouseover.native="mouseOver($event)"
        @mouseleave.native="mouseLeave($event)">
        土地開發
      </router-link>
      <router-link to="/#series3"
        :class="this.has_custom_colors ? '' : 'default'"
        :style="this.text_style"
        @mouseover.native="mouseOver($event)"
        @mouseleave.native="mouseLeave($event)">
        乳品生產管理
      </router-link>
      <router-link to="/#series4"
        :class="this.has_custom_colors ? '' : 'default'"
        :style="this.text_style"
        @mouseover.native="mouseOver($event)"
        @mouseleave.native="mouseLeave($event)">
        多元特色課程
      </router-link>
      <router-link to="/#about-project"
        :class="this.has_custom_colors ? '' : 'default'"
        :style="this.text_style"
        @mouseover.native="mouseOver($event)"
        @mouseleave.native="mouseLeave($event)">
        翻轉學習發展重點
      </router-link>
      <router-link to="/#about-team"
        :class="this.has_custom_colors ? '' : 'default'"
        :style="this.text_style"
        @mouseover.native="mouseOver($event)"
        @mouseleave.native="mouseLeave($event)">
        計畫團隊
      </router-link>
      <router-link :x-to="{ name: 'ApplySteps' }" to="/#course-apply"
        class="default course-apply"
        :style="this.text_style"
        >
        課程申請
      </router-link>
      <a class="login-button" href="" target="_blank" v-on:click.prevent="clickLogin"></a>
    </Slide>
    <div class="overlay" :class="[ menuOpenState ? '' : 'hide' ]"></div>
  </div>
</template>
<script>
  import $ from 'jquery'
  import { globalMixin, platformMixin, courseMixin, GuardMixin } from '@/components/_Mixins'
  import { Slide, ScaleDown } from 'vue-burger-menu'
  import Hashes from 'jshashes'

  const md5 = require('md5')
  const config = require('../../config')

  const _expand_menu_width = '250px'

  export default {
    data() {
      return {
        menuOpenState: false,
        expand_menu_width: _expand_menu_width,
      }
    },

    mounted() {
      // console.log('TopMenu.vue', 'mounted !!')
      let _this = this

      let createJqDiv = function(className) {
        return $(document.createElement('div')).addClass(className)
      }
      let createSprite = function(className) {
        let $_container = createJqDiv('sprite')
        let $_sprite = createJqDiv(`sprite-${className}`)
        $_container.addClass(`sprite-${className}-absolute`)

        return $_container.append($_sprite)
      }
      // console.log(this.$route)
      setTimeout(() => {
        $('.bm-burger-button').remove()
        let $menu_hotspot = createSprite('menu')
        $('.menu-mobile-hotspot')
          .html('')
          .append($menu_hotspot)

        $menu_hotspot.click(function($e) {
          $e.preventDefault()
          $e.stopPropagation()

          _this.menuOpenState = !_this.menuOpenState
        })

        $('.hidden-always').removeClass('hidden-always')

        $(function() {
            $('#TopMenu ul lo a').each(function(index, item) {
                var $item = $(item)

            })
        })

      }, 100);

      // setTimeout(() => {
      //   let menu = _this.$refs.SideMenu
      //   console.log('TopMenu.vue',
      //     'SideMenu check',
      //     _this.$refs.SideMenu,
      //     menu)
      //   _this.menuOpenState = true
      // }, 3000)

      var keepWatchTopMenuHeight = (timeout) => {
        var height = $('#TopMenu ul').height()
        $('.login-button').height(height)

        setTimeout(keepWatchTopMenuHeight, timeout)
      }
      keepWatchTopMenuHeight(100)
    },

    mixins: [ globalMixin, platformMixin, courseMixin, GuardMixin ],

    components: {
      Slide, ScaleDown
    },

    methods: {
      scrollMeTo(name) {

          if (name == 'top') {
              // window.scrollTo(0, 0)
              this.scrollToPosition(0)
              return false
          }

          //var element = this.$refs[refName];
          var elements = document.getElementsByName(name);

          if (elements && elements.length > 0) {
              let element = elements[0]
              let $element = $(element)

              console.log('>>> TopMenu.vue > element : ', $element, element.offsetTop)

              let top = element.offsetTop

              window.scrollTo(0, top)

              return false
          }
      },

      getClassList($target) {
        if (!$target) return undefined
        if (!$target.attr) return undefined

        var classList = $target.attr('class').split(/\s+/)
        // $.each(classList, function(index, item) {
        //     if (item === 'someClass') {
        //         //do something
        //     }
        // })

        classList = classList.filter(function (el) {
          return el != undefined && el != null && el.length > 0
        })

        return classList
      },

      handleOpenMenu($event) {
        let _this = this

        setTimeout(() => {
          // $('body')
          //   .addClass('mobilebm-overlay')
          //   .addClass('mobile')

          let classes = _this.getClassList($('body'))
          let new_classes = []

          if (classes && Array.isArray(classes)) {
            classes.forEach((className) => {
              if (className.indexOf('-overlay') == -1) {
                new_classes.push(className)
              }
              if (className == 'mobilebm-overlay') {
                new_classes.push('mobile')
              }
            })
          }

          new_classes.push('bm-overlay')

          // console.log('TopMenu.vue',
          //   'handleOpenMenu()',
          //   'menu opened !',
          //   classes,
          //   new_classes)

          // re add new classes
          $('body')
            .attr('class', '')
            .addClass(new_classes)

          let _stopPropagation = function($e) {
            $e.preventDefault()
            $e.stopPropagation()
          }

          let overlay_clicked = function($e) {
            _stopPropagation($e)

            console.log('TopMenu.vue',
              'overlay clicked !')
            _this.menuOpenState = false

            return false
          }

          $('.overlay')
            .one('click', overlay_clicked)
            // .unbind('click', overlay_clicked)
            // .bind('click', overlay_clicked)

          $('.menu-mobile, .bm-menu')
            .one('click', function($e) { _stopPropagation($e); return false; })

        }, 100)
      },

      handleCloseMenu($event) {

      },

      mouseOver($event) {
        //let course =
        // console.log('mouseOver in TopMenu.vue', $event, this.colors)

        let el = $event.target

        //el.style.color)
        if (this.has_custom_colors) {
          if (el.hasOwnProperty('original-color') == false) {
            el['original-color'] = el.style.color
          }
          if (el.hasOwnProperty('original-background-color') == false) {
            el['original-background-color'] = el.style.backgroundColor
          }

          if (this.colors['top-menu'].hasOwnProperty('hover_text')) {
            el.style.color = this.colors['top-menu'].hover_text
          }
          if (this.colors['top-menu'].hasOwnProperty('hover_background')) {
            el.style.backgroundColor = this.colors['top-menu'].hover_background
          }
        }
      },

      mouseLeave($event) {
        let el = $event.target

        //el.style.color = this['top-menu-color']
        // el.style = this.hover_text_style
        el.style.color = el['original-color']
        el.style.backgroundColor = el['original-background-color']
      },

      itemClick($event, hash) {
        // console.log('## itemClick',
        //   '[router watch]',
        //   '$event',
        //   $event,
        //   'hash',
        //   hash)
        this.scrollToHash({hash: hash})
      },

      goUrl(series_id, course_id) {
        console.log('goUrl', this.$router.go)

        // this.$router.push({ name: 'Course', params: { series_id: series_id, course_id: course_id }})
        this.$router.go({
          name: 'Course',
          params: { series_id: series_id, course_id: course_id },
          force: true,
        })
      },

      goPortal(hash) {
        this.$router.go({
          name: 'Portal',
          hash: hash,
          force: true,
        })
      },

      async clickLogin(e) {
        e.preventDefault()
        e.stopPropagation()

        let SHA512 = new Hashes.SHA512
        //let sha512 = SHA512.hex(`${config.Secret}::Sce5858`)
        //console.log('Salt password : ', sha512)

        let Swal = this.$swal

        const { value: password } = await Swal.fire({
          title: 'Enter your password',
          input: 'password',
          inputPlaceholder: 'Enter your password',
          inputAttributes: {
            maxlength: 50,
            autocapitalize: 'off',
            autocorrect: 'off'
          }
        })

        if (password) {
          if (SHA512.hex(`${config.Secret}::${password}`) == config.JsonEditorPassword) {
            //Swal.fire('OK')
            this.$router.push('editor')
          }
          else {
            Swal.fire('Goodbye')
          }
        }
      },

    },

    computed: {

      menu() {
        let menu = _this.$refs.SideMenu

        return menu
      },

      menu_width: {
        get() {
          let $menu = $('.menu-container .bm-menu')

          return $menu.width()
        },
        set(value) {
          setTimeout(() => {
            let $menu_container = $('.menu-container')
            $menu_container.width(value)

            let $menu = $($menu_container.find('.bm-menu'))
            $menu.width(value)

            // if (value == 0) {
            //   $('body').removeClass('bm-overlay')
            // }
          }, 200)
        }
      },

      has_custom_colors: function () {
        if (this.colors === undefined) return false

        if (this.colors.hasOwnProperty('top-menu') == false) return false

        //return this.colors && this.colors['top-menu']
        return true
      },

      colors() {
        let colors = this.getCourseSettingColors()

        //console.log('TopMenu.vue', 'computed', 'colors', colors)

        if (colors && colors.hasOwnProperty('top-menu')) {
          // return {
          //   'top-menu': {
          //     background: 'rgba(0, 0, 0, .6)',
          //     text: '#ffffff',
          //     hover_text: '#ffd603',
          //   }
          // }

          //console.log('TopMenu.vue', 'computed', 'colors', 'top-menu', colors)

          return colors
        }

        return undefined
      },

      background_style() {
        if (this.has_custom_colors) {
          let colors = this.colors['top-menu']

          let propertyName = 'background-color'
          let key = 'background'

          if (colors.hasOwnProperty(key)) {
            console.log('TopMenu.vue',
              '# check top-menu color settiong',
              `${propertyName}: ${colors[key]};`)
            return `${propertyName}: ${colors[key]};`
          }
        }

        return ''
      },

      text_style() {
        if (this.has_custom_colors) {
          let colors = this.colors['top-menu']

          let propertyName = 'color'
          let key = 'text'

          if (colors.hasOwnProperty(key)) {
            return `${propertyName}: ${colors[key]};`
          }
        }

        return ''
      },

      hover_text_style() {
        if (this.has_custom_colors) {
          let colors = this.colors['top-menu']

          let propertyName = 'color'
          let key = 'hover_text'

          if (colors.hasOwnProperty(key)) {
            return `${propertyName}: ${colors[key]};`
          }
        }

        return ''
      },

      hover_background_style() {
        if (this.has_custom_colors) {
          let colors = this.colors['top-menu']

          let propertyName = 'color'
          let key = 'hover_background'

          if (colors.hasOwnProperty(key)) {
            return `${propertyName}: ${colors[key]};`
          }
        }

        return
      },
    },

    watch: {
    // //   '$route': (to, from) => {
    // //     console.log('watch', to, from)
    // //   }
      menuOpenState: function (value) {
        console.log('TopMenu.vue',
            'check menu_width : ',
            this.menu_width,
            'check menuOpenState : ',
            value)

        if (value == true) {
          // if (this.menu_width == 0) {
            this.menu_width = _expand_menu_width
          // }
        }
        else {
          this.menu_width = 0
          // $('.bm-overlay').removeClass('bm-overlay')
        }
      },
    },

    // beforeRouteEnter (to, from, next) {
    //     debugger
    //     // just use `this`
    //     console.log('>>> beforeRouteUpdate this, to, from, next', this, to, from, next)
    //     //this.name = to.params.name
    //     next(false)
    // },
  }

</script>



// WEBPACK FOOTER //
// src/components/Menu/TopMenu.vue